import styled from 'styled-components';

export const SurveyContainer = styled.div`
  p {
    margin: 0;
  }

  .ant-rate {
    font-size: 2rem;
    display: inline;
  }

  .rating-character {
    position: relative;
    display: grid;
    place-items: center;
    .rating-character-number {
      font-weight: bold;
      font-size: 0.7rem;
      color: ${({ theme }) => theme.colors.primary};
      position: absolute;
    }
  }
`;

export const SurveyHeader = styled.div`
  text-align: center;
  margin-bottom: 64px;

  svg {
    max-height: 220px;
  }

  h1 {
    font-weight: bold;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  p {
    opacity: 0.6;
    max-width: 300px;
    margin: 0 auto;
  }
`;

export const CompletedResearchContainer = styled.div`
  padding: 24px;
  text-align: center;

  svg {
    max-height: 300px;
  }

  h1 {
    font-weight: bold;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  p {
    font-size: 1rem;
    opacity: 0.6;
    max-width: 300px;
    margin: 0 auto;
  }
`;
